import React from "react";

import Button from "components/ui/Button";

// Shown when Midtrans sends the learner back with ?order_id=.
export default function PaymentSuccess({ order, meta }) {
  return (
    <div className="yc-empty is-solid">
      {meta.course_thumbnail && <img className="yc-tx-success-img" src={meta.course_thumbnail} alt="" />}
      <h1 className="yc-h1">Tahniah! You&apos;re in.</h1>
      <p className="yc-muted">
        Payment received for <strong>{meta.course_name ?? "your class"}</strong>.
      </p>
      <Button to={`/courses/${order.course_id}`}>Start learning</Button>
    </div>
  );
}
